import { useEffect, useRef } from 'react';
import { useActions, useSelector } from '../components/runtime-context';
import { getNormalizedPostSlug } from '../services/post-utils';
import { getIsPostMetadataLoaded } from '../store/is-loaded/is-loaded-selectors';
import { type NormalizedPost } from '../types';

export const useLoadedMetadataForPost = (post: NormalizedPost) => {
  const actions = useActions();
  const isMetadataLoaded = useSelector(getIsPostMetadataLoaded);
  const postSlug = getNormalizedPostSlug(post);
  const isDemo = Boolean(post.isDemo);
  const postRef = useRef(post);
  postRef.current = post;

  useEffect(() => {
    if (!postSlug && !isDemo) {
      return;
    }

    if (isMetadataLoaded) {
      return;
    }

    actions.fetchPostMetadata(postRef.current);
  }, [actions, isMetadataLoaded, postSlug, isDemo]);

  return isMetadataLoaded;
};
